import { render } from "./SettingsModal.vue?vue&type=template&id=6100b640&scoped=true&ts=true"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=6100b640&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6100b640"]])

export default __exports__